module.exports = __webpack_public_path__ + "static/media/3010.c2a5dcc6.jpg";